export interface DrivelogUser {
  id: string;
  name: string;
  email: string;
  roles: string[];
}

export abstract class AuthService {
  abstract isAuthenticated(): boolean;
  abstract getToken(): string | null;
  abstract getUser(): DrivelogUser | null;
  abstract login(): void;
  abstract logout(): void;

  /** Attempt to silently renew the current session. Resolves false if the session is truly expired. */
  abstract refreshToken(): Promise<boolean>;
}
